import React, { Component } from "react";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import { withRedux, displayError, validateEmail } from "helpers";
import { AlertModal } from "components";
import { H1 } from "appStyles";
import { permissionOptions } from "constants";
import { inviteUser } from "apis";
import { css } from "react-emotion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const storeContainer = css`
  margin: 0px 20px;
  @media only screen and (min-width: 768px) {
    margin: 0px 40px;
  }
`;

const arrowStyle = css`
  font-size: 1.75em;
  display: flex;
  align-self: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    font-size: 2em;
    cursor: pointer;
    display: flex;
    align-self: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

function InviteUser({
  activeApp: { id },
  actions: { setDisplay, updateUserApplicationsPermissions },
}) {
  const [values, setValue] = React.useState({
    email: "",
    firstName: "",
    lastName: "",
    permissions: [0],
    showInvited: false,
  });

  const { email, firstName, lastName, permissions, showInvited } = values;

  const goBack = () => {
    setDisplay({
      view: "Permissions",
      templateId: null,
    });
  };

  const handleSubmit = async () => {
    if (!email || !firstName || !lastName)
      return displayError("Input fields cannot be empty");
    if (!validateEmail(email)) return displayError("Invalid email address");
    // console.dir(permissions);

    const prepPermissions = permissions.join(",");
    try {
      await inviteUser(email, firstName, lastName, id, permissions);
      setValue({
        email: "",
        firstName: "",
        lastName: "",
        permissions: [],
        showInvited: true,
      });
    } catch (e) {
      console.error(e);
    }
  };

  const permissionOnChange = (options) => {
    const permissions = options.map((op) => op.value);
    setValue({ ...values, permissions });
  };

  const renderPermissionOptions = () => {
    const value = permissionOptions.filter((option) =>
      permissions.includes(option.value)
    );
    return (
      <div
        style={{
          margin: "1em 0 1em 0",
        }}
      >
        <Select
          isMulti
          name="permissions"
          value={value}
          // value={{
          //   value: 0,
          //   label: 'ADMIN'
          // }}
          options={permissionOptions}
          onChange={permissionOnChange}
        />
      </div>
    );
  };

  const handleChange = (name) => (event) => {
    setValue({ ...values, [name]: event.target.value });
  };

  const renderBackArrow = () => {
    return (
      <FontAwesomeIcon
        className={arrowStyle}
        icon="arrow-left"
        onClick={goBack}
      />
    );
  };

  return (
    <div
      style={{
        margin: "0px 40px",
        width: "735px",
      }}
    >
      <AlertModal
        title="Invitation Status"
        render={showInvited}
        buttonText="Ok"
        hideModal={() => {
          setValue({ ...values, showInvited: false });
          goBack();
        }}
      >
        <p>Your invitation is on the way!</p>
      </AlertModal>
      {renderBackArrow()}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <H1 margin="0">Invite an Admin</H1>
        <TextField
          required={true}
          label="Email"
          placeholder="Email"
          value={email}
          onChange={handleChange("email")}
        />
        <TextField
          required={true}
          label="First Name"
          placeholder="First Name"
          value={firstName}
          onChange={handleChange("firstName")}
        />
        <TextField
          required={true}
          label="Last Name"
          placeholder="Last Name"
          value={lastName}
          onChange={handleChange("lastName")}
        />
      </div>
      <br />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {/* <FormControl>
          <H1 margin="0">Permissions</H1>
          {renderPermissionOptions()}
        </FormControl> */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          style={{
            display: "inline-flex",
            alignItems: "center",
            margin: "0px",
            textAlign: "center",
            boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
          }}
        >
          Invite
        </Button>
      </div>
    </div>
  );
}

export default withRedux(InviteUser);
